import { useEffect, useState } from "react";
import api from "@/lib/api";
import { MarketingPage } from "@/components/marketing/MarketingPage";
import { PAGE_BANNERS } from "@/lib/assets";
import { BookOpen, ExternalLink, ShieldAlert, Calculator } from "lucide-react";

export default function Research() {
  const [m, setM] = useState(null);
  useEffect(() => { api.get("/methodology").then(({ data }) => setM(data)); }, []);

  return (
    <MarketingPage
      eyebrow="Research & Methodology"
      banner={PAGE_BANNERS.research}
      title="Built on evidence, shown in the open"
      lead="GPA+ figures are grounded in the LSC Transferable Skills Guide and current, peer-reviewed and government labor-market research. Here's exactly what informs each number — and the limits of a prototype."
    >
      {!m && <p className="text-slate-500">Loading…</p>}
      {m && (
        <div className="space-y-10">
          <section>
            <h2 className="flex items-center gap-2 font-heading text-2xl font-bold text-[#003057]">
              <Calculator className="h-6 w-6 text-[#78be21]" /> How each figure is derived
            </h2>
            <div className="mt-4 space-y-3">
              {m.figure_basis.map((f) => (
                <div key={f.figure} className="rounded-xl border border-slate-200 bg-white p-4 card-elevate" data-testid="figure-basis-item">
                  <p className="font-heading text-base font-bold text-[#003057]">{f.figure}</p>
                  <p className="mt-1 text-sm text-slate-600">{f.basis}</p>
                </div>
              ))}
            </div>
          </section>

          <section>
            <h2 className="flex items-center gap-2 font-heading text-2xl font-bold text-[#003057]">
              <BookOpen className="h-6 w-6 text-[#78be21]" /> Supporting research
            </h2>
            <div className="mt-4 space-y-3">
              {m.research.map((r) => (
                <div key={r.title} className="rounded-xl border border-slate-200 bg-white p-4 card-elevate" data-testid="research-item">
                  <div className="flex flex-wrap items-center gap-2">
                    <span className="rounded-full bg-[#003057]/8 px-2.5 py-0.5 text-xs font-bold text-[#003057]">{r.source}</span>
                    <span className="font-mono-num text-xs text-slate-400">{r.year}</span>
                  </div>
                  <a href={r.url} target="_blank" rel="noopener noreferrer"
                    className="mt-2 flex items-center gap-1.5 font-heading text-base font-bold text-[#005291] hover:text-[#78be21]">
                    {r.title} <ExternalLink className="h-3.5 w-3.5" />
                  </a>
                  <p className="mt-1 text-sm text-slate-600">{r.supports}</p>
                </div>
              ))}
            </div>
          </section>

          <section>
            <h2 className="flex items-center gap-2 font-heading text-2xl font-bold text-[#003057]">
              <ShieldAlert className="h-6 w-6 text-[#78be21]" /> Disclaimers & limitations
            </h2>
            <ul className="mt-4 space-y-2 rounded-2xl bg-slate-100 p-6">
              {m.disclaimers.map((d, i) => (
                <li key={i} className="flex gap-2 text-sm text-slate-600" data-testid="disclaimer-item">
                  <span className="mt-1.5 h-1.5 w-1.5 flex-shrink-0 rounded-full bg-slate-400" /> {d}
                </li>
              ))}
            </ul>
          </section>
        </div>
      )}
    </MarketingPage>
  );
}
